import { render, staticRenderFns } from "./actaVuepdf.vue?vue&type=template&id=4e44d5a4"
import script from "./actaVuepdf.vue?vue&type=script&lang=js"
export * from "./actaVuepdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports